"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = exports.Collection = void 0;
var react_aria_components_1 = require("react-aria-components");
Object.defineProperty(exports, "Collection", { enumerable: true, get: function () { return react_aria_components_1.Collection; } });
Object.defineProperty(exports, "Section", { enumerable: true, get: function () { return react_aria_components_1.Section; } });
//# sourceMappingURL=Collection.js.map